export { Text, Anchor } from './Text';
